export enum ESearchMode {
  extended = 'extended',
  minimized = 'minimized',
}
